<template>
  <div class="library-item" :class="{'is-asset': isAsset}">
    <div class="top">
      <a :href="itemLink" class="preview"
         v-bind:style='{ backgroundImage: bgImg }'>
        <div class="has-quiz flex-center" title="This presentation has quiz(es)" v-if="item.quizCount"><img src="/static/Q.svg" alt=""></div>
        <!--<div class="category flex-center has-icon"  v-if="item.categories.length"><img src="/static/science.svg" alt=""><span>{{item.categories[0].name}}</span></div>-->
        <div class="category flex-center" :class="{'has-icon': item.categories[0].image}" v-if="item.categories && item.categories.length"><img v-if="item.categories[0].image" :src="item.categories[0].image.url" alt=""><span>{{item.categories[0].name}}</span></div>
      </a>
      <div class="metrics" v-if="!min && !isAsset && (item.slideCount !== undefined || item.views !== undefined)">
        <div
           v-if="item.slideCount !== undefined"
           class="slides" :title="'This presentation has ' + item.slideCount + ' slides'" v>
          <div><img src="/static/slides.svg" alt=""></div>
          <div>{{item.slideCount}}</div>
        </div>
        <div
           v-if="item.views !== undefined"
           class="views"
           :title="'This presentation was viewed ' + (item.views ? item.views : 0) + ' times'">
          <div><img src="/static/eye.svg" alt=""></div>
          <div>{{item.views ? item.views : 0}}</div>
        </div>
      </div>
    </div>
    <div class="bottom">
        <a :href="itemLink" class="title">
          <span>{{item.title || item.name}}</span>
        </a>

      <div class="tags flex-center hidden-xs-only" v-if="!min">
        <el-button v-for="tag,i in sliceArray(item.tags, 0, 3)" :key="tag+i" size="mini" type="primary" plain>{{tag.name}}</el-button>
      </div>
    </div>
    <div class="overflow-hidden" v-if="!min">
      <div class="hover-block">
            <div class="tags flex-center hidden-xs-only flex-wrap" v-if="item.tags && item.tags.length > 4">
              <el-button v-for="tag,i in sliceArray(item.tags, 4, item.tags.length)" :key="tag+i" size="mini" type="primary" plain>{{tag.name}}</el-button>
            </div>

            <!-- <div class="description hidden-xs-only" v-if="item.description">
              <div>{{item.description}}</div>
            </div> -->
            <div class="buttons-wrap" >
              <div class="buttons d-flex flex-grow">
                <a  :href="itemLink" class="btn-main flex-center">view</a>
                <a  v-if="$store.state.loggedIn && (item.owner === $store.state.user._id || $store.state.user.cooboTeam)" :href="editLink" class="btn-main flex-center">edit</a>
                <a  v-if="$store.state.loggedIn && (item.author && item.author._id === $store.state.user._id)" :href="editLink" class="btn-main flex-center">edit</a>
                <div class="no-shrink d-flex hidden-xs-and-down additional-btns">
                  <a v-if="$store.state.loggedIn && (item.owner === $store.state.user._id || $store.state.user.cooboTeam)" :href="buildLink" class="flex-center edit-btn" title="Builder"><img src="/static/edit.svg" alt=""></a>
                  <a v-if="$store.state.loggedIn" class="flex-center edit-btn" title="Share" @click="openShareModal"><img src="/static/share.svg"></a>
                  <a v-if="$store.state.loggedIn" class="flex-center edit-btn" title="Duplicate" v-on:click="duplicateTour"><img src="/static/duplicate.svg"></a>
                  <a v-if="$store.state.loggedIn && (item.owner === $store.state.user._id || $store.state.user.cooboTeam)" class="flex-center edit-btn" title="Delete" v-on:click="openDeleteModal"><img src="/static/waste-bin.svg"></a>
                </div>
              </div>

            </div>
            <div class="tags flex-center hidden-sm-and-up flex-wrap" style="order: 1">
              <el-button v-for="tag,i in sliceArray(item.tags, 0, 8)" :key="tag+i" size="mini" type="primary" plain>{{tag.name}}</el-button>
            </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'LibraryItem',
    props: {
      item: {
        type: Object
      },
      isAsset: {
        type: Boolean,
        default: false
      },
      min: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {}
    },
    methods: {
      duplicateTour() {
        let jwt = this.$store.state.env === "development" ? ("?jwt=" + localStorage.getItem("jwt")) : ""
        this.axios.post(this.$store.state.API_URL + "demo/duplicate/" + this.item._id).then( (res) => {
          window.location.href = this.$store.state.API_URL + 'edit/' + res.data._id + jwt;
        });
      },
      sliceArray(arr, start, end) {
        if (end > start + 8) {
          end = start + 8;
        }
        return arr ? arr.slice(start, end+1) : [];
      },
      openAssignModal() {
        this.$emit("assign", this.item._id);
      },
      openShareModal() {
        this.$emit("share", this.item._id);
      },
      openDeleteModal() {
        this.$emit("delete", this.item);
      }
    },
    computed: {
      itemLink() {
        return this.item.url || (this.$store.state.API_URL + (this.isAsset ? 'view_asset/' : 'view/') + this.item._id);
      },
      editLink() {
        let jwt = this.$store.state.env === "development" ? ("?jwt=" + localStorage.getItem("jwt")) : "";
        return this.$store.state.API_URL + (this.isAsset ? 'edit_asset/' : 'edit/') + this.item._id + jwt;
      },
      buildLink() {
        let jwt = this.$store.state.env === "development" ? ("?jwt=" + localStorage.getItem("jwt")) : "";
        return this.$store.state.API_URL + 'build/' + this.item._id + jwt;
      },
      bgImg() {
        let item = this.item;
        if (this.item.thumbUrl) {
          return "url(" + this.item.thumbUrl + ")"
        }
        if (this.isAsset) {
          item.thumb = item.thumbnail;
        }
        let host = this.$store.state.s3Url;
        let url = item.thumb ? (item.thumb[0] === "/" ? "": "/") + item.thumb : "/" + (this.item.s3Id ? this.item.s3Id : "assets") + "/" + ((item.uuid ? item.uuid : item._id) + "-thumb.jpg");
        return "url(" + host + url + ")"
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/library-item.vue